import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('AUTH', {
  AUTH_LOGIN_REQUEST: null,
  AUTH_LOGIN_SUCCESS: null,
  AUTH_LOGIN_ERROR: null,
  AUTH_LOGOUT: null,
  AUTH_LOAD_USER_REQUEST: null,
  AUTH_LOAD_USER_SUCCESS: null,
  AUTH_LOAD_USER_FAILURE: null,
  OPEN_LOGIN_OVERLAY: null,
  CLOSE_LOGIN_OVERLAY: null,
  REQUIRES_LIBRARY_ACCOUNT: null
});




// WEBPACK FOOTER //
// ./app/constants/AuthConstants.js